import React from "react";
import { Skeleton } from "@common/skeleton";

import { Props } from "./types";
import styles from "./styles.scss";

function Project(props: Props) {
  return (
    <div className={styles.project}>
      <div className={styles.header}>
        <div>
          <Skeleton className={styles.icon} />
        </div>
        <div className={styles.main}>
          <Skeleton className={styles.name} />
        </div>
      </div>
    </div>
  );
}

export { Project };
